import React from 'react'
import styles from "../myprofile/myprofile.module.css"
import ProfileMenu from '../../Components/profilemenu/ProfileMenu'
import Orderscomp from '../../Components/orderscomp/Orderscomp'
import Myprofile from '../myprofile/Myprofile'
import { useLocation } from 'react-router-dom'

const OrderDetails = () => {
    const location = useLocation()
    // "0" = cart order, "1" = PO order; from the list (page state) or from an email link (?tab=0|1)
    const tab = location.state ?? new URLSearchParams(location.search).get('tab')
  
    
    return (
        <>
             <Myprofile>
             
                <Orderscomp tab={tab}/>
            </Myprofile>
        </>
    )
}

export default OrderDetails